import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'

export default function PasswordInput({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoComplete,
  className = '',
  hasError = false,
  ...props
}) {
  const [visible, setVisible] = useState(false)

  return (
    <div className="relative">
      <input
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={`${className} pr-12`}
        {...props}
      />
      <motion.button
        type="button"
        whileTap={{ scale: 0.9 }}
        onClick={() => setVisible(v => !v)}
        tabIndex={-1}
        className="absolute right-0 top-0 h-full px-3.5
          flex items-center justify-center
          text-text-muted hover:text-text-secondary
          transition-colors duration-150
          focus-visible:outline-none"
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? (
          <EyeSlashIcon className="w-5 h-5" />
        ) : (
          <EyeIcon className="w-5 h-5" />
        )}
      </motion.button>
    </div>
  )
}
